import { IApplicationState } from '../../types/redux';

export const selectIsBuildersProjectsTabEnabled = (state: IApplicationState): boolean => {
  const {
    buildersProjectsLocations,
    geo: { location },
  } = state;

  return Boolean(location && buildersProjectsLocations.includes(location.id));
};
